import React from 'react';
import { Link, Text } from '@backstage/ui';
import styles from './tile.module.css';

interface TileProps {
  href: string;
  onClick?: () => void;
  compact?: boolean;
  leading?: React.ReactNode;
  title: string;
  subtitle?: string;
  description?: string;
  trailing?: React.ReactNode;
}

export const Tile = ({
  href,
  onClick,
  compact,
  leading,
  title,
  subtitle,
  description,
  trailing,
}: TileProps) => {
  return (
    <Link href={href} onClick={onClick} className={styles.link}>
      <div className={`${styles.tile}${compact ? ` ${styles.compact}` : ''}`}>
        {leading && <div className={styles.leading}>{leading}</div>}
        <div className={styles.content}>
          <div className={styles.header}>
            <Text variant="body-medium" weight="bold">
              {title}
            </Text>
            {trailing && <div className={styles.trailing}>{trailing}</div>}
          </div>
          {subtitle && (
            <Text variant="body-x-small" color="secondary">
              {subtitle}
            </Text>
          )}
          {description && (
            <Text variant="body-small" color="secondary" className={styles.description}>
              {description}
            </Text>
          )}
        </div>
      </div>
    </Link>
  );
};
